import { useEffect, useState } from "react";
import { useDebounce } from "react-use";
import { useAppSelector } from "~/redux/store/store";

export function useViewportSize(): void {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);
  const [headerHeight, setHeaderHeight] = useState(0);
  const { headerVisible, isMobile } = useAppSelector((s) => s.general);

  useDebounce(
    () => {
      const vh = window.innerHeight * 0.01;
      // document.documentElement.style.setProperty("--vh", `${vh}px`);
      document.documentElement.style.setProperty("--full-vh", `${vh * 100}px`);
      const header = document.getElementById("app-header");
      document.documentElement.style.setProperty(
        "--header-height",
        `${header?.clientHeight ?? 0}px`,
      );
      document.documentElement.style.setProperty(
        "--content",
        `${vh * 100 - (header?.clientHeight ?? 0)}px`,
      );
    },
    500,
    [innerHeight, headerHeight, headerVisible, isMobile],
  );

  useEffect(() => {
    const fn = () => {
      const vh = window.innerHeight * 0.01;
      setInnerHeight(vh);
      const header = document.getElementById("app-header");
      setHeaderHeight(header?.clientHeight ?? 0);
    };

    window.addEventListener("resize", fn);
    return function cleanup() {
      window.removeEventListener("resize", fn);
    };
  }, []);
}
